export const PlaceHolder = {
  SELECT_SEGMENT: "Choose project segment",
  SELECT_STATUS: "Choose status",
  SELECT_MEP_CUSTOMER: "Choose MEP contractors",
  SELECT_MAIN_CUSTOMER: "Choose a contractors",
  SELECT_DESIGN_CONSULTANT: "Choose a consultant",
  SELECT_SUPER_CONSULTANT: "Choose a supervision consultant",
  SELECT_CLIENT: "Choose a client",
  SELECT_DISTRIBUTOR: "Choose a distributor",
  SELECT_COUNTRY: "Choose your country",
  SELECT_DEPARTMENT: "Choose a department",
  SELECT_DESIGNATION: "Choose a designation",
  SELECT_POSITION: "Choose position",
  SELECT_PROJECT: "Choose a project",
  SELECT_CUSTOMER: "Choose a customer",
  SELECT_SALES_ENGINEER: "Choose a sales engineer",
  SELECT_AUTHORIZED_PERSON: "Choose a authorized person",
  SELECT_ENQUIRY: "Choose enquiry",
  SELECT_QUOTE_VALIDITY: "Choose quote validity",
  SELECT_PAYMENT_TERMS: "Choose payment terms",
  SELECT_DELIVERY_LEAD_TIME: "Choose delivery lead time",
  SELECT_DELIVERY_TERMS: "Choose delivery terms",
  SELECT_TRANSPORT_MODE: "Choose mode of transport",
  SELECT_CURRENCY: "Choose a currency",
  SELECT_COMPANY: "Choose a company",

  //Update Status
  SELECT_LOST_REASON: "Choose lost reason",
  LOST_TO: "Enter lost to",
  LOST_DETAILS: "Enter lost details",
  LOST_PRICE: "Enter lost price",

  //Project
  PROJECT_NAME: "Enter project name",
  PROJECT_CODE: "Enter project code",

  //Company
  COMPANY_NAME: "Enter company name",
  COMPANY_CODE: "Enter company code",

  CONTACT_NAME: "Enter contact name",
  EMAIL: "Enter email",
  PHONE_NUMBER: "Enter phone number",
  ADDITIONAL_NOTES: "Enter your notes here",
  WEB_SITE: "Enter web address",
  FAX: "Enter fax number",
  NAME: "Enter name",
  ADDRESS: "Enter your address",

  //Payment
  PAYMENT_TERMS: "Enter payment terms",
  CREDIT_DAYS: "Enter days",
  DESCRIPTION: "Enter description",
  SELECT_PROJECT_NAME: "Choose a project name",

  //Customer
  CUSTOMER_NAME: "Enter customer name",
  EMAIL_ADDRESS: "Enter email address",
  SELECT_CUSTOMER_TYPE: "Choose customer type",
  SELECT_ENGINEER: "Choose an engineer",
  ABBREVIATION: "Enter abbreviation",
  DELIVERYTERMS: "Enter delivery terms",
  DESCRIPTION_TOOL: "Enter description (tool tips)",

  //User Master
  FIRST_NAME: "Enter first name",
  LAST_NAME: "Enter last name",
  PASSWORD: "Enter password",
  CONFIRM_PASSWORD: "Enter confirm password",
  PHONE: "Enter phone number",
  SELECT_REPORTING: "Choose reporting to",
  SELECT_USER_ROLE: "Choose user role",
  SELECT_USER_TYPE: "Choose user type",

  //Role Permission
  ROLE_NAME: "Enter role name",

  //Distributor
  DISTRIBUTOR_NAME: "Enter distributor name",
  SELECT_DISTRIBUTOR_TYPE: "Choose distributor type",
  CONVERSION_RATE: "Enter conversion exchange",
  ENTER_AUTH_NAME:"Enter authorized person",
  ENTER_POSITION:"Enter position",

  //Enquiry
  SELECT_DISTRIBUTOR_CUSTOMER: "Choose distributor to display customers",
  SELECT_DISTRIBUTOR_PROJECT: "Choose distributor to display projects",
  ENQUIRY_REFERENCE: "Enter enquiry reference",
  ENQUIRY_TYPE: "Choose enquiry type",
  SELECT_ASSIGNED: "Choose assigned engineer",
  SELECT_ALLOCATED_TO: "Choose allocated to",
  SHOULD_CHOOSE_FIELD: (fieldName) => `Choose distributor to display ${fieldName}`,
  MUST_CHOOSE_FIELD: (chooseField,displayField) => `Choose ${chooseField} to display ${displayField}`,

  //Multiplier Master
  SELECT_GROUP:"Select group",
  SELECT_FAMILY:"Select family",

  //Order
  SELECT_QUOTE_REF:"Select quote reference",
};

